module.exports = __webpack_public_path__ + "static/media/deleteIconActive.120f4f02.svg";